import { render } from "./AddDepot.vue?vue&type=template&id=71833d6f&ts=true"
import script from "./AddDepot.vue?vue&type=script&lang=ts"
export * from "./AddDepot.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__